package com.nonopn.skywatcher.design.widgets.abslists

import eu.codlab.viewmodel.StateViewModel
import eu.codlab.viewmodel.launch
import kotlinx.coroutines.CoroutineScope

interface AbstractListModelState<E> {
    val modelState: ListModelStateHolder<E>
}

abstract class AbstractListModel<T : AbstractListModelState<E>, E>(
    defaultState: T
) : StateViewModel<T>(defaultState) {
    abstract fun load()

    abstract fun isMatch(entity: E, filter: String): Boolean

    abstract fun onNewStateHolder(newHolder: ListModelStateHolder<E>)

    fun filter(filter: String) = launch {
        filter {
            isMatch(it, filter)
        }
    }

    fun filter(predicate: (entity: E) -> Boolean) = launch {
        val entities = states.value.modelState.objects
        val filtered = entities.filter { predicate(it) }

        onNewStateHolder(
            states.value.modelState.copy(
                filtered = filtered,
                predicate = predicate
            )
        )
    }

    protected fun safeLaunch(block: suspend CoroutineScope.() -> Unit) = launch(
        onError = defaultOnError,
        run = block
    )

    private val defaultOnError: (throwable: Throwable) -> Unit = {
        println("error obtained")
        it.printStackTrace()

        onNewStateHolder(
            states.value.modelState.copy(
                state = ListModelState.ERROR
            )
        )
    }
}
